import { render, staticRenderFns } from "./PcSolveShow.vue?vue&type=template&id=5ab21b28&scoped=true&"
import script from "./PcSolveShow.vue?vue&type=script&lang=js&"
export * from "./PcSolveShow.vue?vue&type=script&lang=js&"
import style0 from "./PcSolveShow.vue?vue&type=style&index=0&id=5ab21b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab21b28",
  null
  
)

export default component.exports